import { Dispatch } from "redux";
import { setSecurityRulesLoading, setSecurityRules } from "@redux/actions/security-rules-actions";
import { AxnAdminSecurityRule } from "@idw-types/data/management-console/axnadmin";
import { getAxnAdminSecurityRulesRequest } from "@requests/management-console/get-axn-admin-security-rules";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";

export const getSecurityRulesReduxRequest = (dispatch: Dispatch) => async (): Promise<Array<AxnAdminSecurityRule>> => {
    dispatch(setSecurityRulesLoading(true));
    const { data, error } = await getAxnAdminSecurityRulesRequest();
    if (data?.axnAdminSecurityRules) {
        dispatch(setSecurityRules(data.axnAdminSecurityRules));
        return data.axnAdminSecurityRules;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.getSecurityRules.error.title,
                resources.requests.getSecurityRules.error.message
            );
        }
        dispatch(setSecurityRulesLoading(false));
        return null;
    }
};